module.exports = __webpack_public_path__ + "img/可领任务类型.c4586d59.png";